import styles from "./CardSkeletonTrackingDetails.module.css";

const CardSkeletonTrackingDetail = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.BackButtonWrapper}>
        <div className={styles.CircleSkeleton}></div>
      </div>

      <div className={styles.MainWrapper}>
        <div className={styles.LeftSide}>
          <ul className={styles.SkeletonList}>
            {[...Array(5)].map((_, index) => (
              <li key={index} className={styles.ListItemSkeleton}></li>
            ))}
          </ul>
        </div>

        <div className={styles.RightSide}>
          <div className={styles.TopDetailSkeleton}></div>
          <div className={styles.BottomDetailSkeleton}></div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeletonTrackingDetail;
